import loadable from '@loadable/component';

export const error_country_home = loadable(() => import("./CountryHomePage"));
export const error_error_code = loadable(() => import("./ErrorCodePage"));